module.exports = __webpack_public_path__ + "assets/img/qr.37795ad7.jpg";